import React from "react";
import { useForm } from "react-hook-form";
import { CForm, CButton } from "@coreui/react";

import CustomSelect from "components/CustomSelect";
import CustomInput from "components/CustomInput";
import { typeIds } from "constants/typeId";

function BookingByID({ events, getReservation, onCancel }) {
  const { handleSubmit, errors, control, register } = useForm();

  return (
    <CForm className="form-horizontal">
      <p>
        {!events.length && <b>No hay eventos para el día de hoy</b>}
        {events.length && <b>Ingresa los datos de tu reserva</b>}
      </p>

      <CustomSelect
        name="eventId"
        placeholder="Selecciona el servicio de la reserva"
        control={control}
        errors={errors}
        required
        options={events}
        defaultValue={events[0] ? events[0].value : null}
      />
      <CustomSelect
        name="typeId"
        placeholder="Tipo de identificación"
        control={control}
        errors={errors}
        required
        options={typeIds}
        defaultValue={typeIds[0].value}
      />
      <CustomInput
        name="numberId"
        placeholder="Número de identificación"
        control={control}
        errors={errors}
        required
        type="text"
        defaultValue={""}
        register={register}
      />
      <CButton
        onClick={handleSubmit(getReservation)}
        size="sm"
        color="info"
        style={{ marginRight: "10px" }}
      >
        Consultar reserva
      </CButton>
      {onCancel && (
        <CButton onClick={onCancel} size="sm" color="danger">
          Cancelar
        </CButton>
      )}
    </CForm>
  );
}

export default BookingByID;
